import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { Icon } from '../../index';
import usePickerInput from '../hooks/use-picker-input';
import { getInputSize, getPlaceholder, elementsContains } from '../utils';

function InputDate(props, ref) {
  var _classnames, _context, _classnames2;

  var inputRef = props.inputRef,
      panelDivRef = props.panelDivRef,
      id = props.id,
      autoFocus = props.autoFocus,
      allowClear = props.allowClear,
      className = props.className,
      borderType = props.borderType,
      disabled = props.disabled,
      hoverValue = props.hoverValue,
      picker = props.picker,
      propsPlaceholder = props.placeholder,
      style = props.style,
      size = props.size,
      text = props.text,
      needConfirmButton = props.needConfirmButton,
      dateValue = props.dateValue,
      selectedValue = props.selectedValue,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      format = props.format,
      open = props.open,
      readOnly = props.readOnly,
      prefixCls = props.prefixCls,
      locale = props.locale,
      dataOrAriaProps = props.dataOrAriaProps,
      disabledDate = props.disabledDate,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onContextMenu = props.onContextMenu,
      onClick = props.onClick,
      resetText = props.resetText,
      setSelectedValue = props.setSelectedValue,
      triggerTextChange = props.triggerTextChange,
      triggerOpen = props.triggerOpen,
      triggerChange = props.triggerChange;
  var preventBlurRef = useRef(false);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMouseEnter = _useState2[0],
      setIsMouseEnter = _useState2[1];

  var placeholder = getPlaceholder(picker, locale, propsPlaceholder);

  var getSuffixNode = function getSuffixNode() {
    if (isMouseEnter && (hoverValue || text) && allowClear) {
      return null;
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon || /*#__PURE__*/React.createElement(Icon, {
      type: picker === 'time' ? 'waiting' : 'date'
    }));
  };

  var mouseEnterHandle = function mouseEnterHandle(e) {
    setIsMouseEnter(true);

    if (typeof onMouseEnter === 'function') {
      onMouseEnter(e);
    }
  };

  var mouseLeaveHandle = function mouseLeaveHandle(e) {
    setIsMouseEnter(false);

    if (typeof onMouseLeave === 'function') {
      onMouseLeave(e);
    }
  };

  var clearNode;

  if (allowClear && dateValue && !disabled) {
    clearNode = /*#__PURE__*/React.createElement("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerChange(null);
        triggerOpen(false);
      },
      className: "".concat(prefixCls, "-clear")
    }, clearIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid"
    }));
  }

  var onInternalMouseUp = function onInternalMouseUp() {
    if (onMouseUp) {
      onMouseUp.apply(void 0, arguments);
    }

    if (inputRef.current) {
      inputRef.current.focus();
      triggerOpen(true);
    }
  };

  var onInternalonMouseDown = function onInternalonMouseDown() {
    if (onMouseDown) {
      onMouseDown.apply(void 0, arguments);
    }

    if (open) {
      preventBlurRef.current = true;
      requestAnimationFrame(function () {
        preventBlurRef.current = false;
      });
    }
  };

  var _usePickerInput = usePickerInput({
    preventBlurRef: preventBlurRef,
    blurToCancel: needConfirmButton,
    open: open,
    value: text,
    triggerOpen: triggerOpen,
    // forwardKeyDown,
    isClickOutside: function isClickOutside(target) {
      return !elementsContains([panelDivRef.current, ref.current], target);
    },
    onSubmit: function onSubmit() {
      if (selectedValue && disabledDate && disabledDate(selectedValue)) {
        return false;
      }

      triggerChange(selectedValue);
      triggerOpen(false);
      resetText();
      return true;
    },
    onCancel: function onCancel() {
      triggerOpen(false);
      setSelectedValue(dateValue);
      resetText();
    },
    onFocus: onFocus,
    onBlur: onBlur
  }),
      _usePickerInput2 = _slicedToArray(_usePickerInput, 2),
      inputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      focused = _usePickerInput2$.focused,
      typing = _usePickerInput2$.typing;

  var borderClass = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classnames, "".concat(prefixCls, "-borderless"), borderType === 'none'), _classnames));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classnames(prefixCls, className, borderClass, (_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classnames2, "".concat(prefixCls, "-focused"), focused), _defineProperty(_classnames2, _concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, size), size), _classnames2)),
    style: style,
    onMouseDown: onInternalonMouseDown,
    onMouseUp: onInternalMouseUp,
    onMouseEnter: mouseEnterHandle,
    onMouseLeave: mouseLeaveHandle,
    onContextMenu: onContextMenu,
    onClick: onClick
  }, dataOrAriaProps), /*#__PURE__*/React.createElement("div", {
    className: classnames("".concat(prefixCls, "-input"), _defineProperty({}, "".concat(prefixCls, "-input-placeholder"), !!hoverValue))
  }, /*#__PURE__*/React.createElement("input", _extends({
    // className={classnames({
    //   [`${prefixCls}-input-${size}`]: size,
    // })}
    id: id,
    ref: inputRef,
    // tabIndex={tabIndex}
    disabled: disabled,
    readOnly: readOnly || typeof format === 'function' || !typing,
    value: hoverValue || text,
    onChange: function onChange(e) {
      triggerTextChange(e.target.value);
    },
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: autoFocus,
    placeholder: placeholder,
    title: text
  }, inputProps, {
    size: getInputSize(picker, format)
  })), getSuffixNode(), clearNode));
}

export default /*#__PURE__*/React.forwardRef(InputDate);